import cn from 'classnames';
import React, { useState } from 'react';

import { Icon } from '../Icon/Icon';

import { Input } from './Input';
import inputStyles from './Input.module.scss';
import { FieldProps } from './Input.types';

const InternalInputPassword: React.ForwardRefRenderFunction<
  HTMLInputElement,
  FieldProps
> = (props, ref) => {
  const { className, ...restBaseInputProps } = props;

  const [showPassword, togglePassword] = useState(false);

  return (
    <Input
      ref={ref}
      {...restBaseInputProps}
      className={cn(inputStyles.withRightButton, className)}
      type={showPassword ? 'text' : 'password'}
    >
      <button
        className={cn(
          inputStyles.inputControlButton,
          restBaseInputProps.disabled && inputStyles.disabled,
        )}
        type="button"
        disabled={restBaseInputProps.disabled}
        onClick={() => togglePassword(!showPassword)}
      >
        <Icon size={24} name={showPassword ? 'eyeClosed' : 'eye'} />
      </button>
    </Input>
  );
};

export const InputPassword = React.forwardRef<HTMLInputElement, FieldProps>(
  InternalInputPassword,
);
